import React from "react";
import { Link } from "react-router-dom";
import PageSeo from "components/Seo/PageSeo";
import { useSelector } from "react-redux";
import PageHero from "components/PageHero/PageHero";
import "components/Home/homeShared.css";
import "styles/siteChrome.css";
import "./careerPage.css";

const INVESTING_COPY =
  "We invest in our team through hands-on training, mentorship, and ongoing professional development. Whether you are new to coaching or bringing years of experience, you will have the support and resources to grow alongside our athletes.";

const CareerPage = () => {
  const career = useSelector((state) => state.contentfulReducer.career);

  const joinSection = career?.sections?.[0];
  const valuesSection = career?.sections?.[1];
  const joinImageUrl = joinSection?.image?.fields?.file?.url;

  const scrollToTop = () => window.scrollTo(0, 0);

  return (
    <main className="careers-page">
      <PageSeo
        title="Employment Opportunities"
        description="Join the Ace Gymnastics team in Bardstown, KY. Coaching and staff roles in a supportive, family-owned gymnastics facility."
        path="/employment"
      />

      <PageHero
        title={career?.title || "Join Our Team"}
        subtitle="Help shape confident athletes and build your career at a family-owned gym in Bardstown, Kentucky."
        imageAlt="Ace Gymnastics coaching"
      />

      <section className="home-section careers-page__intro" aria-labelledby="join-team-heading">
        <div className="home-section__inner careers-page__intro-grid">
          <div className="careers-page__intro-text">
            <h2 id="join-team-heading" className="home-section__title">
              {joinSection?.title || "Join Our Team"}
            </h2>
            {joinSection?.description ? (
              <p className="careers-page__lead">{joinSection.description}</p>
            ) : (
              <p className="careers-page__lead">
                Join Ace Gymnastics and be part of a supportive community
                dedicated to excellence, safety, and growth. If you love
                gymnastics and inspiring young athletes, we would love to meet
                you.
              </p>
            )}
            <h3 className="careers-page__subheading">Investing in you</h3>
            <p className="careers-page__body">{INVESTING_COPY}</p>
          </div>
          {joinImageUrl && (
            <div className="careers-page__intro-image">
              <img
                src={joinImageUrl}
                alt={joinSection?.title || "Ace Gymnastics coach with athlete"}
                width="600"
                height="450"
                loading="lazy"
              />
            </div>
          )}
        </div>
      </section>

      <section className="careers-page__cta" aria-label="Apply for a position">
        <div className="careers-page__cta-inner">
          <h2 className="careers-page__cta-title">Ready to make an impact?</h2>
          <p className="careers-page__cta-text">
            View our current opening and apply online in a few minutes.
          </p>
          <Link
            to="/job-application"
            onClick={scrollToTop}
            className="site-btn site-btn--accent"
            data-track="employment_apply_click"
            data-track-location="employment_page"
          >
            View application details
          </Link>
        </div>
      </section>

      {valuesSection?.values?.length > 0 && (
        <section
          className="home-section home-section--alt careers-page__values"
          aria-labelledby="values-heading"
        >
          <div className="home-section__inner">
            <header className="home-section__header careers-page__values-header">
              <h2 id="values-heading" className="home-section__title">
                {valuesSection.title || "Our ACE Values"}
              </h2>
              <p className="home-section__subtitle">
                The principles that guide how we coach, collaborate, and care
                for every family in our gym.
              </p>
            </header>
            <ul className="careers-page__values-grid">
              {valuesSection.values.map((item, index) => (
                <li key={item.value || index} className="careers-value-card">
                  <h3 className="careers-value-card__title">{item.value}</h3>
                  <p className="careers-value-card__desc">{item.description}</p>
                </li>
              ))}
            </ul>
          </div>
        </section>
      )}
    </main>
  );
};

export default CareerPage;
